/* Presentation only: never alter merchandise data, forms, or line identifiers. */
(()=>{
 const ignore='script,style,textarea,input,select,option,pre,code,[contenteditable="true"]';
 const code=/\b(?:\d{3,}|whl\d+)_+[A-Za-z][A-Za-z0-9_]*\b/gi;
 const clean=s=>s.replace(code,v=>v.replace(/^(?:\d+|whl\d+)_+/i,'').replace(/_/g,' '));
 function sweep(root){
  if(root.nodeType!==1||root.closest(ignore))return;
  root.querySelectorAll('tr').forEach(row=>{
   const cells=row.querySelectorAll('th,td');if(!cells.length)return;
   const label=cells[0].textContent.trim().replace(/:$/,'').toLowerCase();
   if(label==='sku'||label==='stock keeping unit'||(label==='model name'&&/\d+_/.test(row.textContent)))row.hidden=true;
  });
  const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let node;
  while((node=walker.nextNode())){
   if(node.parentElement.closest(ignore)||!node.textContent.trim())continue;
   let next=clean(node.textContent);
   if(/^\s*(?:SKU|Stock keeping unit)\s*:/i.test(next)){
    const holder=node.parentElement;
    if(holder.children.length===0){holder.hidden=true;continue;}
   }
   if(next!==node.textContent)node.textContent=next;
  }
 }
 let pending=false;
 const run=()=>{pending=false;observer.disconnect();sweep(document.body);observer.observe(document.body,{childList:true,subtree:true,characterData:true});};
 const observer=new MutationObserver(()=>{if(!pending){pending=true;requestAnimationFrame(run);}});
 run();
})();
